import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

type MovieCardProps = {
  movie: Movie;
  index?: number;
  compact?: boolean;
};

export default function MovieCard({ movie, index = 0, compact = false }: MovieCardProps) {
  return (
    <article
      className="group animate-fade-up"
      style={{ animationDelay: `${Math.min(index, 8) * 45}ms` }}
    >
      <Link to={`/detail/${movie.id}`} className="block cursor-pointer">
        <div className="relative w-full overflow-hidden rounded-lg bg-background-200">
          <div className={`${compact ? "aspect-[2/3]" : "aspect-[2/3]"} w-full`}>
            <img
              src={movie.poster}
              alt={`${movie.title} 海报`}
              title={`${movie.title} 高清在线观看`}
              className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.04]"
            />
          </div>
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/5 to-transparent opacity-70 transition-opacity duration-500 group-hover:opacity-95" />

          <span className="absolute left-2.5 top-2.5 flex items-center gap-1 rounded-full bg-background-50/92 px-2 py-1 font-label text-[11px] font-bold text-primary-700">
            <i className="ri-star-fill text-[10px] w-[10px] h-[10px] flex items-center justify-center text-accent-500" />
            {movie.rating.toFixed(1)}
          </span>

          <span className="absolute inset-x-0 bottom-0 flex items-center justify-between px-3 pb-2.5">
            <span className="flex flex-wrap gap-1">
              {movie.genres.slice(0, 2).map((genre) => (
                <span
                  key={genre}
                  className="rounded bg-foreground-950/45 px-1.5 py-0.5 text-[10px] text-background-50"
                >
                  {genre}
                </span>
              ))}
            </span>
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-500 text-background-50 opacity-0 transition-all duration-300 group-hover:opacity-100">
              <i className="ri-play-fill text-sm w-4 h-4 flex items-center justify-center" />
            </span>
          </span>
        </div>

        <div className="mt-2.5">
          <h3 className="clamp-2 text-sm font-medium leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-[15px]">
            {movie.title}
          </h3>
          <p className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 font-label text-[11px] text-foreground-500 md:text-xs">
            <span>{movie.year}</span>
            <span className="h-1 w-1 rounded-full bg-foreground-300" />
            <span>{movie.region}</span>
            <span className="h-1 w-1 rounded-full bg-foreground-300" />
            <span>{movie.duration} 分钟</span>
          </p>
        </div>
      </Link>
    </article>
  );
}